import { api } from '@/lib/api/client';
import type { NotificationFeed } from './types';

export function fetchNotifications(): Promise<NotificationFeed> {
  return api.get<NotificationFeed>('/me/notifications');
}

export function markNotificationsRead(body: { keys: string[] } | { all: true }): Promise<{ unread_count: number }> {
  return api.post<{ unread_count: number }>('/me/notifications/read', body);
}
